<template>
  <master-layout :show-footer="false" :full-width="true">
    <div class="bg-[#F6F4F0] w-full min-h-screen pb-[64px]">
      <BackButton class="w-full px-5 md:px-6 lg:px-8 mb-[8px]" :customBack="back" />

      <div class="w-full md:max-w-2xl md:mx-auto px-5 md:px-6 lg:px-8">
        <h1
          class="text-[#3D3A35] font-[900] text-[1.5rem] leading-[2rem] mb-[16px]"
          data-test="waiting-for-link-title"
        >
          MyGiving
        </h1>
        <DsAlert variant="info" data-test="waiting-for-link-notice">
          {{ message }}
        </DsAlert>
      </div>
    </div>
  </master-layout>
</template>

<script>
import MasterLayout from '@/components/MasterLayout.vue';
import BackButton from '@/components/common/BackButton.vue';
import { Alert as DsAlert } from '@team-hogc/hogc-one-design-system';
import { LINK_REQUIRED_MESSAGE } from '@/utils/member-split/link-required';

// What a login still waiting for its CG leader's link sees in place of MyGiving.
// The MyGiving link guard sends it here; there is no PIN to ask for yet.
export default {
  name: 'MyGivingWaitingForLink',
  components: { MasterLayout, BackButton, DsAlert },
  data() {
    return { message: LINK_REQUIRED_MESSAGE };
  },
  methods: {
    back() {
      this.$router.replace('/home');
    },
  },
};
</script>
